@if (cancelService.status() === 1) {
  <div class="zwi-main-content zwi-justify-center">
    <zwi-widget>
      <div>Loading</div>
      <!--    <zwi-progress-indicator></zwi-progress-indicator>-->
    </zwi-widget>
  </div>
} @else {
  @switch (cancelService.result().status) {
    @case ('success') {
      <zwi-simple-page>
        <zwi-call-to-action>
          <ng-container title>Your account has been closed.</ng-container>
        </zwi-call-to-action>
      </zwi-simple-page>
    }
    @case ('expired') {
      <zwi-simple-page>
        <zwi-call-to-action>
          <ng-container title>Close account link has expired.</ng-container>
        </zwi-call-to-action>
      </zwi-simple-page>
    }
  }
}
